import { DollarOutlined, HomeOutlined, TeamOutlined } from '@ant-design/icons';

export interface IRoute {
  path: string;
  title: string;
  description?: string;
  permission?: string;
  icon?: any;
  children?: IRoute[];
  isAdmin?: boolean;
}

export enum Route {
  PAGE500 = 'PAGE500',
  PAGE403 = 'PAGE403',

  LOGIN = 'LOGIN',

  HOME = 'HOME',
  NHAN_VIEN = 'NHAN_VIEN',
  BANG_LUONG = 'BANG_LUONG',
}

export const Routes: { [key in Route]: IRoute } = {
  PAGE500: {
    path: '/loi',
    title: 'Lỗi hệ thống',
  },
  PAGE403: {
    path: '/loi-quyen-truy-cap',
    title: 'Lỗi quyền truy cập',
  },

  LOGIN: {
    path: '/dang-nhap',
    title: 'Đăng nhập',
  },

  HOME: {
    path: '/',
    title: 'Trang chủ',
    icon: <HomeOutlined />,
  },
  NHAN_VIEN: {
    path: '/nhan-vien',
    title: 'Nhân viên',
    icon: <TeamOutlined />,
  },
  BANG_LUONG: {
    path: '/tong-hop-luong',
    title: 'Tổng hợp lương',
    icon: <DollarOutlined />,
  },
};
